/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FisiologicaGeneraleDTO
 */
export interface FisiologicaGeneraleDTO {
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    deambulazioneTipoId?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    deambulazioneAusilioId?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    deambulazioneNote?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FisiologicaGeneraleDTO
     */
    uditoAssenza?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    uditoPatologiaOrecchioDestro?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    uditoPatologiaOrecchioSinistro?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    uditoPatologiaOrecchie?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    uditoNote?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FisiologicaGeneraleDTO
     */
    visioneAssenza?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    visionePatologiaOcchioDestro?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    visionePatologiaOcchioSinistro?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    visionePatologiaOcchi?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    visioneNote?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    medicoSSNCognome?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    medicoSSNNome?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    medicoSSNTelefono?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    medicoSSNCellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    medicoSSNEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    medicoSSNCitta?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    medicoSSNNote?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    altroOssigeno?: string;
    /**
     * 
     * @type {string}
     * @memberof FisiologicaGeneraleDTO
     */
    altroNote?: string;
}

/**
 * Check if a given object implements the FisiologicaGeneraleDTO interface.
 */
export function instanceOfFisiologicaGeneraleDTO(value: object): value is FisiologicaGeneraleDTO {
    return true;
}

export function FisiologicaGeneraleDTOFromJSON(json: any): FisiologicaGeneraleDTO {
    return FisiologicaGeneraleDTOFromJSONTyped(json, false);
}

export function FisiologicaGeneraleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FisiologicaGeneraleDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'deambulazioneTipoId': json['deambulazione_TipoId'] == null ? undefined : json['deambulazione_TipoId'],
        'deambulazioneAusilioId': json['deambulazione_AusilioId'] == null ? undefined : json['deambulazione_AusilioId'],
        'deambulazioneNote': json['deambulazione_Note'] == null ? undefined : json['deambulazione_Note'],
        'uditoAssenza': json['udito_Assenza'] == null ? undefined : json['udito_Assenza'],
        'uditoPatologiaOrecchioDestro': json['udito_PatologiaOrecchioDestro'] == null ? undefined : json['udito_PatologiaOrecchioDestro'],
        'uditoPatologiaOrecchioSinistro': json['udito_PatologiaOrecchioSinistro'] == null ? undefined : json['udito_PatologiaOrecchioSinistro'],
        'uditoPatologiaOrecchie': json['udito_PatologiaOrecchie'] == null ? undefined : json['udito_PatologiaOrecchie'],
        'uditoNote': json['udito_Note'] == null ? undefined : json['udito_Note'],
        'visioneAssenza': json['visione_Assenza'] == null ? undefined : json['visione_Assenza'],
        'visionePatologiaOcchioDestro': json['visione_PatologiaOcchioDestro'] == null ? undefined : json['visione_PatologiaOcchioDestro'],
        'visionePatologiaOcchioSinistro': json['visione_PatologiaOcchioSinistro'] == null ? undefined : json['visione_PatologiaOcchioSinistro'],
        'visionePatologiaOcchi': json['visione_PatologiaOcchi'] == null ? undefined : json['visione_PatologiaOcchi'],
        'visioneNote': json['visione_Note'] == null ? undefined : json['visione_Note'],
        'medicoSSNCognome': json['medicoSSN_Cognome'] == null ? undefined : json['medicoSSN_Cognome'],
        'medicoSSNNome': json['medicoSSN_Nome'] == null ? undefined : json['medicoSSN_Nome'],
        'medicoSSNTelefono': json['medicoSSN_Telefono'] == null ? undefined : json['medicoSSN_Telefono'],
        'medicoSSNCellulare': json['medicoSSN_Cellulare'] == null ? undefined : json['medicoSSN_Cellulare'],
        'medicoSSNEmail': json['medicoSSN_Email'] == null ? undefined : json['medicoSSN_Email'],
        'medicoSSNCitta': json['medicoSSN_Citta'] == null ? undefined : json['medicoSSN_Citta'],
        'medicoSSNNote': json['medicoSSN_Note'] == null ? undefined : json['medicoSSN_Note'],
        'altroOssigeno': json['altro_Ossigeno'] == null ? undefined : json['altro_Ossigeno'],
        'altroNote': json['altro_Note'] == null ? undefined : json['altro_Note'],
    };
}

export function FisiologicaGeneraleDTOToJSON(value?: FisiologicaGeneraleDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'deambulazione_TipoId': value['deambulazioneTipoId'],
        'deambulazione_AusilioId': value['deambulazioneAusilioId'],
        'deambulazione_Note': value['deambulazioneNote'],
        'udito_Assenza': value['uditoAssenza'],
        'udito_PatologiaOrecchioDestro': value['uditoPatologiaOrecchioDestro'],
        'udito_PatologiaOrecchioSinistro': value['uditoPatologiaOrecchioSinistro'],
        'udito_PatologiaOrecchie': value['uditoPatologiaOrecchie'],
        'udito_Note': value['uditoNote'],
        'visione_Assenza': value['visioneAssenza'],
        'visione_PatologiaOcchioDestro': value['visionePatologiaOcchioDestro'],
        'visione_PatologiaOcchioSinistro': value['visionePatologiaOcchioSinistro'],
        'visione_PatologiaOcchi': value['visionePatologiaOcchi'],
        'visione_Note': value['visioneNote'],
        'medicoSSN_Cognome': value['medicoSSNCognome'],
        'medicoSSN_Nome': value['medicoSSNNome'],
        'medicoSSN_Telefono': value['medicoSSNTelefono'],
        'medicoSSN_Cellulare': value['medicoSSNCellulare'],
        'medicoSSN_Email': value['medicoSSNEmail'],
        'medicoSSN_Citta': value['medicoSSNCitta'],
        'medicoSSN_Note': value['medicoSSNNote'],
        'altro_Ossigeno': value['altroOssigeno'],
        'altro_Note': value['altroNote'],
    };
}

